import React from "react";
import Snap from "snapsvg-cjs";

function extend(a, b) {
  for (var key in b) {
    if (b.hasOwnProperty(key)) {
      a[key] = b[key];
    }
  }
  return a;
}

function SVGButton(el, options) {
  this.el = el;

  this.options = extend({}, this.options);
  extend(this.options, options);
  this.init();
}

SVGButton.prototype.options = {
  speed: { reset: 800, active: 150 },
  easing: { reset: window.mina.elastic, active: window.mina.easein }
};
SVGButton.prototype.init = function() {
  this.shapeEl = this.el.querySelector("span.morph-shape");

  var s = Snap(this.shapeEl.querySelector("svg"));
  this.pathEl = s.select("path");
  this.paths = {
    reset: this.pathEl.attr("d"),
    active: this.shapeEl.getAttribute("data-morph-active")
  };

  this.initEvents();
};

SVGButton.prototype.initEvents = function() {
  this.el.addEventListener("mousedown", this.down.bind(this));
  this.el.addEventListener("touchstart", this.down.bind(this));

  this.el.addEventListener("mouseup", this.up.bind(this));
  this.el.addEventListener("touchend", this.up.bind(this));

  this.el.addEventListener("mouseout", this.up.bind(this));
};

SVGButton.prototype.down = function() {
  this.pathEl
    .stop()
    .animate(
      { path: this.paths.active },
      this.options.speed.active,
      this.options.easing.active
    );
};

SVGButton.prototype.up = function() {
  this.pathEl
    .stop()
    .animate(
      { path: this.paths.reset },
      this.options.speed.reset,
      this.options.easing.reset
    );
};

export default class Button extends React.Component {
  static defaultProps = { color: "#847b84", disabled: false };

  componentDidMount() {
    let element = this.svgDiv;
    new SVGButton(element);
  }
  render() {
    const { color, text, disabled, onClick } = this.props;

    let btn = (
      <button
        className=" button-elastic button-fill button-effect-1"
        ref={d => (this.svgDiv = d)}
        disabled={disabled}
        onClick={onClick}
        type={this.props.type || "button"}
        style={this.props.style}
      >
        <span
          className="morph-shape"
          data-morph-active="M286,113c0,0-68.8-5-136-5c-78.2,0-137,5-137,5s5-15.802,5-50.5C18,33.999,13,12,13,12s59,5,137,5c85,0,136-5,136-5s-5,17.598-5,52C281,96.398,286,113,286,113z"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 300 125"
            preserveAspectRatio="none"
            fill={disabled ? "gray" : color}
          >
            <path d="M286,113c0,0-68.8,0-136,0c-78.2,0-137,0-137,0s0-15.802,0-50.5C13,33.999,13,12,13,12s59,0,137,0c85,0,136,0,136,0s0,17.598,0,52C286,96.398,286,113,286,113z" />
          </svg>
        </span>

        <span className={`button-text ${disabled ? "disabled" : ""}`}>
          {text}
        </span>
      </button>
    );

    return btn;
  }
}



// WEBPACK FOOTER //
// ./src/components/utilities/Button.js